<template>
	<div class="parameter-lists" v-for="(item, index) in lists" :key="index">
		<div class="info-card">
			<div class="title">
				{{ item.name }}
			</div>
			<div class="items">
				<div class="item">
					<div class="label">放电深度</div>
					<div class="value">{{ item.dod }}%</div>
				</div>
				<div class="item">
					<div class="label">综合效率</div>
					<div class="value">{{ item.efficiency }}%</div>
				</div>
				<div class="item">
					<div class="label">变压器容量</div>
					<div class="value">{{ item.demandLimit }}kVA</div>
				</div>
				<div class="item row">
					<div class="label">尖峰平谷电价（元/kWh）</div>
					<div class="value">
						{{ item.electricPrice.join(" - ") }}
					</div>
				</div>
			</div>

			<div class="echarts">
				<div class="echarts-box">
					<echarts-component
						:options="item.options"
					></echarts-component>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import {onMounted, ref, watch, defineProps} from "vue";

// components
import EchartsComponent from "@/components/EchartsComponent.vue";

import {handleTacticsData} from "@/plugins";

const props = defineProps({
	strategyCurveListData: {
		type: Array,
		default: () => {
			return [];
		},
	},
});

const lists = ref([]);

// 处理数据
const handleData = (datas = []) => {
	const arr = [];
	datas.map(row => {
		const {
			dod,
			efficiency,
			demandLimit,
			tfmCapacity,
			sharp,
			peak,
			flat,
			valley,
			ravine,
			name,
			curve,
			timeRanges,
		} = row;

		let obj = {
			dod,
			efficiency,
			demandLimit,
			tfmCapacity,
			electricPrice: [
				sharp ? sharp : "-",
				peak ? peak : "-",
				flat ? flat : "-",
				valley ? valley : "-",
				ravine ? ravine : "-",
			],
			name,
			options: {},
		};

		const Options = handleTacticsData(curve, timeRanges);
		Options.yAxis["axisLabel"] = {
			formatter: function (value) {
				if (value === 0) {
					return "静置";
				} else if (value === 1) {
					return "充电";
				} else if (value === -1) {
					return "放电";
				} else {
					return "-";
				}
			},
		};
		delete Options.legend;
		Options.tooltip = {
			trigger: "axis",
			formatter: params => {
				let str = `-`;
				if (params.length > 0) {
					const value = params[0].data;
					const time = params[0].axisValue;

					if (value === 0) {
						str = "静置";
					} else if (value === 1) {
						str = "充电";
					} else if (value === -1) {
						str = "放电";
					} else {
						str = "-";
					}

					str = `${time} <span style="color: #0BBA74">${str}</span>`;
				}
				return `${str}`;
			},
		};
		Options.color = ["#0BBA74"];
		Options.series[0].step = "start";
		obj.options = Options;
		arr.push(obj);
	});

	lists.value = arr;
};

watch(
	() => props.strategyCurveListData,
	newVal => {
		if (newVal && newVal.length > 0) {
			handleData(newVal);
		}
	},
	{immediate: true, deep: true}
);
</script>

<style lang="less" scoped>
.parameter-lists {
	margin-bottom: 16px;
	.title {
		font-family: PingFangSC-Medium;
		font-weight: 500;
		font-size: 16px;
		color: rgba(0, 0, 0, 0.85);
		letter-spacing: 0;
		padding: 12px 0 8px 0;
		line-height: 24px;
	}
	.info-card {
		background: #a2abbb14;
		border-radius: 4px;
		padding: 0 12px 16px 12px;
		// display: flex;
		// justify-content: space-between;
		// align-items: center;
		// flex-wrap: wrap;
		// margin-top: 8px;
		.items {
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;
			.item {
				margin-bottom: 8px;
				.label {
					height: 22px;
					opacity: 0.65;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 14px;
					color: #000000;
					letter-spacing: 0;
					text-align: justify;
					line-height: 22px;
				}
				.value {
					opacity: 0.85;
					font-family: PingFangSC-Medium;
					font-weight: 600;
					font-size: 14px;
					color: #000000;
					letter-spacing: 0;
					line-height: 22px;
				}
			}
			.row {
				width: 100%;
				// margin-bottom: 0;
			}
		}
	}
}

.echarts {
	// margin-top: 20px;
	// &-title {
	// 	opacity: 0.85;
	// 	font-family: PingFangSC-Medium;
	// 	font-weight: 500;
	// 	font-size: 16px;
	// 	color: #000000;
	// 	letter-spacing: 0;
	// }
	&-box {
		height: 251px;
		// margin-top: 16px;
	}
}
</style>
